module.exports = __webpack_public_path__ + "static/media/thumbnail.66d755cf.jpg";